import { darken, lighten } from 'polished';
import { checkoutLayouts } from '../hooks/useCheckoutState';
import getSafeReadableColor from './getSafeReadableColor';
import isHexColor from './is-hex-color';

function getColors(checkout, checkoutLayout) {
  if (checkoutLayout === checkoutLayouts.CENTER || checkoutLayout === checkoutLayouts.SPLIT) {
    return {
      primaryTextColor: '#000000',
      secondaryTextColor: '#685357',
      backgroundColor: '#ffffff',
      accentColor: darken(0.1, '#ffffff'),
    };
  } else {
    const primaryTextColor = checkout.primaryTextColor || '#000000';
    const secondaryTextColor = checkout.secondaryTextColor || '#685357';

    const backgroundIsDark =
      getSafeReadableColor(checkout.backgroundColor, 'black', 'white') === 'white';

    if (backgroundIsDark) {
      return {
        primaryTextColor,
        secondaryTextColor,
        backgroundColor: checkout.backgroundColor,
        accentColor: isHexColor(checkout.backgroundColor)
          ? lighten(0.25, checkout.backgroundColor)
          : checkout.backgroundColor,
      };
    } else {
      return {
        primaryTextColor,
        secondaryTextColor,
        backgroundColor: checkout.backgroundColor,
        accentColor: isHexColor(checkout.backgroundColor)
          ? darken(0.25, checkout.backgroundColor)
          : checkout.backgroundColor,
      };
    }
  }
}

export default getColors;
